import { LogLevel } from '@/lib/logger';
import type { ColorScheme, PrimaryColor } from '@/styles/theme-v2/theme/types';

import { getSiteURL } from './lib/v2/get-site-url';

export interface Config {
  site: {
    name: string;
    description: string;
    colorScheme: ColorScheme;
    primaryColor: PrimaryColor;
    themeColor: string;
    url: string;
    api: string;
    version: string;
  };
  api: {
    token: string;
    base: string;
  };
  logLevel: keyof typeof LogLevel;
  gtm?: { id?: string };
  url: {
    api: string;
  };
  googleMaps: {
    apiKey: string;
  };
  amplitude: {
    apiKey: string;
    deploymentKey: string;
  };
  pusher: {
    key: string;
    cluster: string;
  };
  features: {
    enableV2Requests: boolean;
  };
  sentry: {
    dsn: string;
  };
  newrelic: {
    accountId: string;
    applicationId: string;
    licenseKey: string;
    trustKey: string;
    agentId: string;
  };
}

export const config = {
  site: {
    name: 'Hoa One',
    description: 'Hoa One',
    colorScheme: 'light',
    themeColor: '#0066cc',
    primaryColor: 'professionalBlue',
    url: getSiteURL(),
    api: import.meta.env.VITE_APP_API_URL,
    version: import.meta.env.VITE_SITE_VERSION || '0.0.0',
  },
  api: {
    token: 'accessToken',
    base: import.meta.env.VITE_APP_API_URL,
  },
  url: {
    api: import.meta.env.VITE_APP_API_URL,
  },
  logLevel: (import.meta.env.VITE_LOG_LEVEL as keyof typeof LogLevel) || LogLevel.ALL,
  gtm: { id: import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID },
  googleMaps: {
    apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  },
  amplitude: {
    apiKey: import.meta.env.VITE_AMPLITUDE_API_KEY,
    deploymentKey: import.meta.env.VITE_AMPLITUDE_DEPLOYMENT_KEY,
  },
  pusher: {
    key: import.meta.env.VITE_PUSHER_KEY,
    cluster: import.meta.env.VITE_PUSHER_CLUSTER,
  },
  features: {
    enableV2Requests: import.meta.env.VITE_ENABLE_V2_REQUESTS === 'true',
  },
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN,
  },
  newrelic: {
    accountId: import.meta.env.VITE_NEWRELIC_ACCOUNT_ID,
    applicationId: import.meta.env.VITE_NEWRELIC_APPLICATION_ID,
    licenseKey: import.meta.env.VITE_NEWRELIC_LICENSE_KEY,
    trustKey: import.meta.env.VITE_NEWRELIC_TRUST_KEY,
    agentId: import.meta.env.VITE_NEWRELIC_AGENT_ID,
  },
} satisfies Config;
